import useSWR from "swr";

import { fetcher } from "../config/axiosConfig.ts";
import { BaseUrl, swrOptions } from "../const.ts";
import { ITickets } from "../model.ts";
import { useParams } from "react-router-dom";

export function useAlltickets() {
  const { detailviewid } = useParams();
  const { data } = useSWR<{ status: string; body: ITickets }>(
    `${BaseUrl}/event-order-ms/ticket/available/${detailviewid}`,
    fetcher,
    swrOptions
  );
  return { tickets: data?.body };
}
